import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const SegmentsRoutes: Routes = [
  {
    path: "segments",
    loadComponent: () =>
      import("./segments/segments.component").then((m) => m.SegmentsComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./segments-list/segments-list.component").then(
            (m) => m.SegmentsListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./segment-form/segment-form.component").then(
            (m) => m.SegmentFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./segment-form/segment-form.component").then(
            (m) => m.SegmentFormComponent,
          ),
      },
      {
        path: "manual/add",
        loadComponent: () =>
          import("./manual-segment-form/manual-segment-form.component").then(
            (m) => m.ManualSegmentFormComponent,
          ),
      },
      {
        path: "manual/view/:id",
        loadComponent: () =>
          import("./manual-segment-form/manual-segment-form.component").then(
            (m) => m.ManualSegmentFormComponent,
          ),
      },
    ],
  },
];
